import { Link, useLocation } from "react-router-dom";
import "../../App.scss"

function Nav() {

    const location = useLocation();

    const isActive = (path) => location.pathname === path;


    return (
        <div className={isActive("/") ? "Nav Nav-home" : "Nav"}>

            <div className="nav-box">
                <Link to='/'>
                    <div className="logo-box">
                        <p className="logoText">Caninely</p>
                    </div>
                </Link>

                <div className="menu">
                    <Link to='/shop'>
                        <p className="menu-item">Shop</p>
                    </Link>
                    <Link to='/categories'>
                        <p className="menu-item">Categories</p>
                    </Link>
                    {/* <Link to='/shop'>
                        <p className="menu-item">Guides</p>
                    </Link> */}
                    {/* <Link to='/shop'>
                        <p className="menu-item">Contact</p>
                    </Link> */}
                    {/* <p className="menu-items">Donate</p> */}
                </div>
            </div>

        </div>
    )
}


export default Nav